import classes from "./ActivityEditor.module.css";
import Skeleton from "react-loading-skeleton";
import React, {useContext, useEffect, useState} from "react";
import {
    ACTIVITY_EDITOR_VIEW,
    ASK_YOUR_QUESTION_HERE_PLACEHOLDER,
    POLL_TYPE,
    QUESTION_LENGTH,
    QUESTION_TYPES,
} from "../../utils/constants";
import ActivityEditorQuestionManagerBar from "./ActivityEditorQuestionManagerBar";
import ActivityEditorQuestionTypeChooser from "./ActivityEditorQuestionTypeChooser";
import ActivityEditorQuestionTitle from "./ActivityEditorQuestionTitle";
import {QUESTION_CHARACTER_LIMIT_EXCEEDED} from "../../utils/toast-message-constants";
import {generateUUID, notifyError} from "../../utils/helpers";
import {initialQuestionData} from "../../utils/questionUtils";
import MCQuestionNew from "../../questions/MCSS/MCQuestionNew";
import TFQuestionNew from "../../questions/TF/TFQuestionNew";
import CIQuestionNew from "../../questions/CI/CIQuestionNew";
import RKQuestionNew from "../../questions/RK/RKQuestionNew";
import MHQuestionNew from "../../questions/MH/MHQuestionNew";
import WCQuestion from "../../questions/WC/WCQuestion";
import {useLocalStorageNew} from "../../hooks/useLocalStorageNew";
import SAQuestion from "../../questions/SA/SAQuestion";
import ActivityEditorOverview from "./ActivityEditorOverview";
import ActivityEditorConfiguration from "./ActivityEditorConfiguration";


export default function ActivityEditorMainView({
                                                   dataLoading,
                                                   editorView,
                                                   setEditorView,
                                                   draftActivity,
                                                   questionBankId,
                                                   setDraftActivity,
                                                   userSettings,
                                                   currQueDisplay,
                                                   setCurrQueDisplay,
                                                   savePoll,
                                                   courseList=[],
                                                   hasReleased=false,
                                                   hasClicked=true,
                                                   setHasClicked
}) {
    const {pollKey, gradeSchema, questions=[]} = draftActivity;

    let isOnQuestionTypeGuidanceView = editorView === ACTIVITY_EDITOR_VIEW.QUESTION_EDITING
    && (questions.length < currQueDisplay || !questions[currQueDisplay - 1].questionType);
    const [shownQuestionType, setShownQuestionType] = useState(QUESTION_TYPES.MCSS.name);
    const [setTempPollKey, getTempPollKey] = useLocalStorageNew("activity_creation_temp_pollKey", "");
    const [mapInitialized, setMapInitialized] = useState(false);
    const [, getToastArr] = useLocalStorageNew("toastArr", []);

    useEffect(() => {
        if (editorView !== ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING) {
            setMapInitialized(false);
        }

    }, [editorView]);



    const getPollKey = () => {
        let tempPollKey = !!pollKey ? pollKey : getTempPollKey();
        if (!tempPollKey) {
            tempPollKey = generateUUID();
            setTempPollKey(tempPollKey);
        }

        return tempPollKey;
    }

    const setQuestions = (questions) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.questions = questions;
        let tempPollKey = getTempPollKey();
        if (!!tempPollKey && !draftActivity.pollKey) {
            copy.pollKey = tempPollKey;

        }

        if (!!tempPollKey && !!draftActivity.pollKey) {
            setTempPollKey("");
        }
        setDraftActivity(copy);

    }

    const setGeofence = (geofence) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.geofence = geofence;
        setDraftActivity(copy);
    }

    const setSyncLms = (syncLms) => {
        const copy = JSON.parse(JSON.stringify(draftActivity));
        copy.syncLms = syncLms;
        setDraftActivity(copy);
    }

    const handleTitleUpdate = (val, plainVal) => {
        if (!plainVal || plainVal.length <= QUESTION_LENGTH) {
            let copy = JSON.parse(JSON.stringify(draftActivity));
            const selectedQuestion= copy.questions.find(q => q.serialNo === currQueDisplay);
            selectedQuestion.queTitle = selectedQuestion.questionType === QUESTION_TYPES.FITB.name ? plainVal : val;
            setDraftActivity(copy);
        } else {
            let toastArr = getToastArr();
            let toastObj = toastArr.find(toastObj => toastObj.message === QUESTION_CHARACTER_LIMIT_EXCEEDED);
            if (!toastObj) {
                notifyError(QUESTION_CHARACTER_LIMIT_EXCEEDED);
            }
        }

        // if(e.target.value.length <= QUESTION_LENGTH) {
        //     setQuestions(updateTitleInput(e.target.value, indexToChange, questions));
        // }
        // else {
        //     notifyError(QUESTION_CHARACTER_LIMIT_EXCEEDED);
        //     setQuestions(updateTitleInput(e.target.value.substring(0, QUESTION_LENGTH), indexToChange, questions));
        // }
    };

    if (!!dataLoading) {
        return (
            <div className={classes.mainViewContainer} style={{flex: 1}}>
                <span style={{width: "100%", height: 60}}>
                    <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={8} style={{lineHeight: "unset"}}/>
                </span>

                <span style={{width: "100%", flex: 1, minHeight: 0}}>
                    <Skeleton highlightColor="lightgrey" width="100%" height="100%" borderRadius={8}/>
                </span>
            </div>
        );
    }

    if (editorView === ACTIVITY_EDITOR_VIEW.OVERVIEW) {
        return (
            <ActivityEditorOverview
                userSettings={userSettings}
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                courseList={courseList}
                setEditorView={setEditorView}
                hasReleased={hasReleased}
                hasClicked={hasClicked}
                setHasClicked={setHasClicked}
            />
        );
    }

    if (editorView === ACTIVITY_EDITOR_VIEW.CONFIGURATION) {
        return (
            <ActivityEditorConfiguration
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                courseList={courseList}
                userSettings={userSettings}
                hasReleased={hasReleased}
            />
        );
    }

    if (isOnQuestionTypeGuidanceView) {
        return (
            <ActivityEditorQuestionTypeChooser
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                currQueDisplay={currQueDisplay}
                userSettings={userSettings}
            />
        );
    }

    if (editorView === ACTIVITY_EDITOR_VIEW.ATTENDANCE_EDITING) {
        return (
            <div className={classes.mainViewContainer} style={{flex: 1, minHeight: 0}}>
                <div className={`${classes.questionMainContainer} create-question-body`} >
                    <ActivityEditorQuestionTitle
                        draftActivity={draftActivity}
                        getPollKey={getPollKey}
                        setQuestions={setQuestions}
                        setDraftActivity={setDraftActivity}
                        currQueDisplay={currQueDisplay}
                        shownQuestionType={QUESTION_TYPES.SA.name}
                        placeholder={ASK_YOUR_QUESTION_HERE_PLACEHOLDER}
                        handleTitleUpdate={handleTitleUpdate}
                    />
                    <SAQuestion
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={questions[currQueDisplay - 1]}
                        pollType={POLL_TYPE.ATTENDANCE}
                        geofence={draftActivity.geofence}
                        setGeofence={setGeofence}
                        syncLms={draftActivity.syncLms}
                        setSyncLms={setSyncLms}
                        mapInitialized={mapInitialized}
                        setMapInitialized={setMapInitialized}
                        userSettings={userSettings}
                        mapView={false}
                    />
                </div>
            </div>
        );
    }

    const selectedQuestion = questions.find(q => q.serialNo === currQueDisplay);

    return (
        <div className={classes.mainViewContainer}>
            <ActivityEditorQuestionManagerBar
                draftActivity={draftActivity}
                setDraftActivity={setDraftActivity}
                currQueDisplay={currQueDisplay}
                setCurrQueDisplay={setCurrQueDisplay}
                shownQuestionType={shownQuestionType}
                setShownQuestionType={setShownQuestionType}
                userSettings={userSettings}
                questionBankId={questionBankId}
                hasReleased={hasReleased}

            />
            <div className={`${classes.questionMainContainer} create-question-body`}>
                <ActivityEditorQuestionTitle
                    draftActivity={draftActivity}
                    getPollKey={getPollKey}
                    setQuestions={setQuestions}
                    setDraftActivity={setDraftActivity}
                    currQueDisplay={currQueDisplay}
                    shownQuestionType={shownQuestionType}
                    placeholder={ASK_YOUR_QUESTION_HERE_PLACEHOLDER}
                    handleTitleUpdate={handleTitleUpdate}
                    savePoll={savePoll}
                    questionBankId={questionBankId}
                />


                {shownQuestionType === QUESTION_TYPES.MCSS.name &&
                    <MCQuestionNew
                        gradeSchema={gradeSchema}
                        getPollKey={getPollKey}
                        setQuestions={setQuestions}
                        questions={questions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                        questionBankId={questionBankId}
                        // dataloading={dataloading}
                        // questionBankId={questionBankId}
                    />
                }

                {shownQuestionType === QUESTION_TYPES.TF.name &&
                    <TFQuestionNew
                        gradeSchema={gradeSchema}
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                    />
                }

                {shownQuestionType === QUESTION_TYPES.CI.name &&
                    <CIQuestionNew
                        gradeSchema={gradeSchema}
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                    />
                }

                {shownQuestionType === QUESTION_TYPES.RK.name &&
                    <RKQuestionNew
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                    />
                }

                {shownQuestionType === QUESTION_TYPES.MH.name &&
                    <MHQuestionNew
                        gradeSchema={gradeSchema}
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                        scrollToBottom={() => {}}
                    />
                }

                {shownQuestionType === QUESTION_TYPES.WC.name &&
                    <WCQuestion
                        questions={questions}
                        setQuestions={setQuestions}
                        selectedQuestion={selectedQuestion.questionType === shownQuestionType ? selectedQuestion : initialQuestionData(shownQuestionType)}
                    />
                }

            </div>
        </div>
    );
}